import { ReactElement, Component } from 'react'

/**
 * Determine if react elements have the same type or constructor
 * @param {ReactElement} element1 
 * @param {ReactElement} element2 
 */
export const areReactElementsSameType = (
  element1,
  element2
) => {
  // Ensure elements exist
  if (!element1 || !element2) {
    return false
  }

  // Ensure type exists and are the same
  return element1.type && element1.type === element2.type
}

/**
 * Determine if react element is the given type
 * @param {ReactElement} element 
 * @param {string|Component} typeOrConstructor 
 */
export const isReactElementOfType = (
  element,
  typeOrConstructor
) => {
  if (!element || !typeOrConstructor) {
    return false
  }

  return element.type === typeOrConstructor
}
